/**
 * Grundwerkzeug fuer die SVG-Zeichnungen des Grubenbildes und der Lupe.
 *
 * Eigenes Modul, weil beide Zeichnungen es brauchen und die Lupe seit dem
 * 25.09.2026 auch INS Grubenbild zeichnet (die Humusauflage als Kachel, siehe
 * `legeAuflageAusKacheln` in auflage-lupe.ts): Laege es weiter in
 * `grubenbild-zeichnen.ts`, importierten sich die beiden Dateien gegenseitig.
 */

const NS = 'http://www.w3.org/2000/svg';

/**
 * Ein SVG-Element mit Attributen und Kindern. Ein Attribut mit `null` oder
 * `undefined` als Wert wird weggelassen.
 */
export function el(name: string, attr?: Record<string, string | number | null | undefined>, kinder?: SVGElement[]): SVGElement {
	const e = document.createElementNS(NS, name) as SVGElement;
	for (const k in (attr ?? {})) {
		const v = attr![k];
		if (v !== null && v !== undefined) e.setAttribute(k, String(v));
	}
	(kinder ?? []).forEach(k => e.appendChild(k));
	return e;
}

/** Deterministischer Zufall - dasselbe Profil sieht immer gleich aus. */
export function streu(seed: number): () => number {
	let z = seed >>> 0;
	return () => {
		z = (z + 0x6d2b79f5) >>> 0;
		let t = Math.imul(z ^ (z >>> 15), 1 | z);
		t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
		return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
	};
}
